import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { Column, GroupTitle, LinkItem, LinksContainer } from './SeoCategoryTreeLinksDesktop.styles';
var buildItems = function buildItems(groups) {
  return groups.reduce(function (items, group) {
    return [].concat(_toConsumableArray(items), [{
      href: group.href,
      label: group.label,
      linksCount: (group.subtree || []).length,
      type: 'title'
    }], _toConsumableArray((group.subtree || []).map(function (link) {
      return {
        href: link.href,
        label: link.label,
        type: 'link'
      };
    })));
  }, []);
};
var adjustEnd = function adjustEnd(items, offset, intendedEnd) {
  var lastIdx = intendedEnd - 1;
  var last = items[lastIdx];
  if (last && last.type === 'title' && last.linksCount >= 1 && lastIdx > offset) {
    return lastIdx;
  }
  var penIdx = intendedEnd - 2;
  var pen = items[penIdx];
  if (pen && pen.type === 'title' && pen.linksCount >= 2 && penIdx > offset) {
    return penIdx;
  }
  return intendedEnd;
};
var distributeItems = function distributeItems(items, columns) {
  var total = items.length;
  var base = Math.floor(total / columns);
  var extra = total % columns;
  var indices = Array.from({
    length: columns
  }, function (_, i) {
    return i;
  });
  return indices.reduce(function (_ref, col) {
    var cols = _ref.cols,
      offset = _ref.offset;
    var intendedSize = base + (col < extra ? 1 : 0);
    var isLast = col === columns - 1;
    var end = isLast ? total : adjustEnd(items, offset, offset + intendedSize);
    return {
      cols: [].concat(_toConsumableArray(cols), [items.slice(offset, end)]),
      offset: end
    };
  }, {
    cols: [],
    offset: 0
  }).cols;
};
var SeoCategoryTreeLinksDesktop = function SeoCategoryTreeLinksDesktop(_ref2) {
  var columns = _ref2.columns,
    groups = _ref2.groups,
    onLinkClick = _ref2.onLinkClick;
  var columnItems = distributeItems(buildItems(groups), columns);
  return React.createElement(LinksContainer, null, columnItems.map(function (items, colIdx) {
    return (React.createElement(Column, {
        key: colIdx
      }, items.map(function (_ref3) {
        var href = _ref3.href,
          label = _ref3.label,
          type = _ref3.type;
        return type === 'title' ? React.createElement(GroupTitle, {
          key: "title-".concat(href),
          href: href,
          onClick: function onClick(e) {
            return onLinkClick(e, href);
          }
        }, label) : React.createElement(LinkItem, {
          key: "link-".concat(href),
          href: href,
          onClick: function onClick(e) {
            return onLinkClick(e, href);
          }
        }, label);
      }))
    );
  }));
};
process.env.NODE_ENV !== "production" ? SeoCategoryTreeLinksDesktop.propTypes = {
  columns: number,
  groups: arrayOf(shape({
    href: string,
    label: string,
    subtree: arrayOf(shape({
      href: string,
      label: string
    }))
  })),
  onLinkClick: func
} : void 0;
SeoCategoryTreeLinksDesktop.defaultProps = {
  columns: 4,
  groups: [],
  onLinkClick: function onLinkClick() {}
};
export default SeoCategoryTreeLinksDesktop;